import { Box, Typography } from '@mui/material';
import React from 'react';

import { SummaryRowProps } from '../types';

const SummaryRow: React.FC<SummaryRowProps> = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 0.75,
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': {
        borderBottom: 'none',
      },
    }}
  >
    <Typography fontWeight={600} variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" color="text.primary">
      {value}
    </Typography>
  </Box>
);

export default SummaryRow;
